import Service from "../services/service";

interface INotificationResult {
  notifications: Array<object>;
  success: boolean;
}

export default class AppNotificationProvider extends Service {
  fetch(json) {
    return this.persist<INotificationResult>({
      endpoint: '',
      json,
    });
  }
  fetchUnread() {
    return this.persist<INotificationResult>({
      endpoint: 'unread'
    });
  }
  markNotificationAsRead(notification) {
    return this.persist<INotificationResult>({
      endpoint: `mark_as_read`,
      method: 'post',
      json: {
        notification_ids: [notification.id]
      }
    });
  }
  markAllAsRead(notifications) {
    return this.persist<INotificationResult>({
      endpoint: 'mark_as_read',
      method: 'post',
      json: {
        notification_ids: notifications.map(n => n.id)
      }
    });
  }

  markNotificationAsUnread(notification) {
    return this.persist<INotificationResult>({
      endpoint: `mark_as_unread`,
      method: 'post',
      json: {
        notification_ids: [notification.id]
      }
    });
  }

  toggleSave(notification) {
    return this.persist<INotificationResult>({
      endpoint: `toggle_save`,
      method: 'post',
      json: {
        app_notification_id: notification.id,
      }
    });
  }

  sendResponseMessage(json) {
    json['overrideBaseEndpoint'] = 'messages';
    return this.persist({
      endpoint: '',
      method: 'post',
      json
    });
  }

  private persist<T extends INotificationResult>({endpoint = '', method = 'get', json = null}: any) {
    return new Promise<T>((resolve, reject) => {
      const data = {
        _method: method
      };

      let baseEndpoint = 'notifications';

      if (json) {
        if (json['overrideBaseEndpoint']) {
          baseEndpoint = json['overrideBaseEndpoint'];
          delete json['overrideBaseInput'];
        }
        if (json['message_notification_ids']) {
          data['message_notifications_ids'] = json['message_notifications_ids'];
          delete json['message_notification_ids'];
        }
        window.AppConfig.mergeJson(data, json);
      }
      $.ajax({
        url: `/${baseEndpoint}/${endpoint}`,
        type: 'POST',
        dataType: 'json',
        data: data,
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}